import { get, postJson } from "@/services/http/backend";
import { SuccessfulResult } from "./types";

export interface User {
  id: number;
  avatarUrl: string;
  companyId: number;
  mainAccount: boolean;
  nickName: string;
  remark: string;
  username: string;
}

export interface SubUser {
  id: number;

  /**是否是主账号 */
  mainAccount: boolean;

  /**昵称 */
  nickName: string;

  /**用户备注名称 */
  remark: string;
}

function getCurrentUserInfo() {
  return get<User>("/user/get");
}

/**获取子账号列表 */
function getSubUserList() {
  return get<SubUser[]>("/user/sub_user/list");
}

/**删除子账号 */
function removeSubUser(userId: number) {
  return postJson<SuccessfulResult>("/user/sub_user/remove", { userId });
}

/**转移主账号权限 */
function transferMainAccount(newMainUserId: number) {
  return postJson<SuccessfulResult>("/user/main_user/transfer", {
    newMainUserId,
  });
}

export { getCurrentUserInfo, getSubUserList, removeSubUser, transferMainAccount };
